import { useState, useContext } from 'react';
import { config } from '../config'
import { User } from "oidc-client-ts"
import { useAuth } from "react-oidc-context";
import GlobalContext from '../store/global-context'
import { getValidationMessagesModalContent } from '../components/shared/helpers'
import { useApi } from 'usbc-web-react-library';

const useDashboardApi = () => {
    const [response, setResponse] = useState(null);

    function getAccessToken() {
        const user = getUser();
        const token = user?.access_token;
        return token;
    }

    const {
        Get: GetApi,
        Post: PostApi,
        loading,
        error,
        setError,
    } = useApi(config.baseUrl, getAccessToken);

    const auth = useAuth();

    const globalCtx = useContext(GlobalContext);
    
    function getPartners() {
        return get({ url: `getpartners` });
    }

    function getOrders() {
        return get({ url: `orders` });
    }

    function addOrder() {
        return get({ url: `addorder` });
    }

    function submitOrder() {
        return post({ url: `submitorder` });
    }

    function cancelOrder(body) {
        return post({ url: 'cancelorder', body: body });
    }
    function hasPermission(permissionNames){
        return get({url:`hasPermission?${permissionNames.map((name) => `permissionNames=${name}`).join("&")}`})
    }

    // TODO LDJ This will be used to allow admins to edit supplies
    // TODO LDJ Change method name to saveSupplies
    function saveOrderForEdit(body, onError) {
        return post({ url: 'saveorderforedit', body: body, onError: onError });
    }

    function saveOrder(body) {
        return post({ url: 'saveorder', body: body });
    }

    function getSuppliesService(body) {
        return post({ url: 'supplies', body: body });
    }

    function getOrderDetails(body) {
        return post({ url: 'orderdetails', body: body });
    }

    function getNewOrderDetails(body) {
        return post({ url: 'neworderdetails', body: body });
    }

    const get = ({
        url,
        params = null,
        headers = null,
        popupValidation = false,
        popupError = false,
        onError = undefined
    }) => {
        return GetApi({ url: url, params: params, headers: headers })
            .then((response) => {
                return parseRowResponse(response);
            })
            .then((responseJson) => {
                return parseJsonResponse(responseJson, popupValidation, popupError, onError);
            });
    };

    const post = ({
        url,
        params = null,
        body = null,
        headers = null,
        popupValidation = false,
        popupError = false,
        onError = undefined
    }) => {
        return PostApi({ url: url, params: params, body: body, headers: headers })
            .then((response) => {
                return parseRowResponse(response);
            })
            .then((responseJson) => {
                return parseJsonResponse(responseJson, popupValidation, popupError, onError);
            });
    };

    function parseRowResponse(response) {
        if (response.status === 401) {
            auth.signinRedirect({
                state: window.location.href,
                extraQueryParams: { app_path: window.location.pathname }
            });
        } else if (response.status === 403) {
            window.location.href = config.selectHubUrl;
        } else {
            return response.json();
        }
    }

    function parseJsonResponse(responseJson,
        popupValidation = false,
        popupError = false,
        onError = undefined) {
        if (responseJson.isSuccess) {
            setResponse(responseJson.data);
            return responseJson.data;
        } else {
            let errors = [...responseJson.validationErrors, ...responseJson.errors]
            setError(errors);
            if (onError) {
                onError(errors);
            }

            if (popupValidation === true &&
                responseJson.validationErrors !== null &&
                responseJson.validationErrors.length > 0) {
                let validationModal = getValidationMessagesModalContent(responseJson.validationErrors);
                globalCtx.showModal(validationModal);
            }

            if (popupError === true &&
                responseJson.errors !== null &&
                responseJson.errors.length > 0) {
                let errorModal = getValidationMessagesModalContent(responseJson.errors);
                globalCtx.showModal(errorModal);
            }
        }
    }

    return {
        getPartners,
        getOrders,
        addOrder,
        submitOrder,
        cancelOrder,
        saveOrder,
        saveOrderForEdit,
        getOrderDetails,
        getNewOrderDetails,
        getSuppliesService,
        hasPermission,
        response, loading, error, setResponse
    };
};

export function getUser() {
    const oidcStorage = localStorage.getItem(`oidc.user:${config.oidcConfig.authority}:${config.oidcConfig.client_id}`)
    if (!oidcStorage) {
        return null;
    }

    return User.fromStorageString(oidcStorage);
}

export default useDashboardApi;